import { ListingState, ListingUserNotification } from "./types";

const DIRECT_LISTING = "direct_listing";
export const SECONDARY_LISTING = "secondary_listing";

export const LISTING_KIND = [DIRECT_LISTING, SECONDARY_LISTING] as const;
export const LISTING_STATE = [
  "open",
  "expired",
  "closed",
  "filled",
  "pending",
  "accepting_final_offers",
] as const;

export const ACCEPTING_OFFERS_STATES: ListingState[] = [
  "open",
  "accepting_final_offers",
];

export const LISTING_DEAL_STATES: ListingState[] = ["filled", "pending"];

export const LISTING_USER_NOTIFICATION_TO_DISPLAY_NAME: Record<
  ListingUserNotification,
  string
> = {
  open: "",
  expired: "",
  closed: "",
  pending: "Pending",
  filled: "Filled",
  filled_for_user: "Filled",
  accepting_final_offers: "Accepting Final Offers",
  awaiting_acceptance: "Offer Made",
  offer_accepted: "Offer Accepted",
  set_price: "Set List Price",
  fail_offer_rejected: "Offer Rejected",
  fail_offer_timeout: "Offer Expired",
  outbid: "Outbid",
};

export const INVESTMENT_TERM = [
  "life_of_rights",
  "30_year",
  "partial_30_year",
  "10_year",
  "partial_10_year",
  "fixed_return",
] as const;

export const ALL_LIFE_OF_RIGHTS_TERMS = ["life_of_rights"];

export const ALL_30_YEAR_TERMS = ["30_year", "partial_30_year"];

export const ALL_10_YEAR_TERMS = ["10_year", "partial_10_year"];

export const ALL_FIXED_RETURN_TERMS = ["fixed_return"];

export const RESALE_INFO_PUBLIC_FIELDS = [
  "id",
  "currency",
  "purchased_amount",
  "purchased_date",
  "purchased_term_expiration_date",
] as const;

export const RESALE_INFO_PRIVATE_FIELDS = [
  "buyer_fee",
  "deal_url",
  "deal_title",
  "incomplete_partial_resale",
  "last_update",
  "prior_payment_amount",
  "previous_hubspot_deal_id",
  "purchased_term",
  "return_on_investment_amount",
  "return_on_investment_percentage",
  "royalties_received",
  "sale_proceeds",
  "total_yield",
  "years_held",
] as const;

export const FEATURED_SOURCES = ["owner", "staff"] as const;
